class GetRangeError extends Error {
  constructor(cause, url, props, code = 'GET_RANGE_ERROR') {
    super("Falha ao obter ranges");
    this.name = 'GetRangeError';
    this.code = code;
    this.cause = cause;
    this.url = url;
    this.props = props;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GetRangeError);
    }
  }
}

module.exports = GetRangeError;